import { useState, useEffect } from 'react';

// Converts "18:00" -> "6:00 PM"
const formatTimeForDisplay = (time24) => {
  if (!time24) return '';
  const [hStr, mStr] = time24.split(':');
  let h = parseInt(hStr, 10);
  const m = mStr || '00';
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m} ${ampm}`;
};

// Converts "6", "6pm", "1430", "2:30a" to "HH:MM" 24h
const parseTimeTo24 = (input) => {
  const clean = input.toLowerCase().replace(/[^0-9ampm:]/g, '');
  if (!clean) return '';
  
  let isPM = true; // default to PM
  if (clean.includes('a')) isPM = false;
  
  const numbersOnly = clean.replace(/[^0-9:]/g, '');
  let h = 0;
  let m = 0;
  
  if (numbersOnly.includes(':')) {
    const parts = numbersOnly.split(':');
    h = parseInt(parts[0] || '0', 10);
    m = parseInt(parts[1] || '0', 10);
  } else if (numbersOnly.length <= 2) {
    h = parseInt(numbersOnly, 10);
  } else if (numbersOnly.length === 3) {
    h = parseInt(numbersOnly.substring(0, 1), 10);
    m = parseInt(numbersOnly.substring(1), 10);
  } else {
    h = parseInt(numbersOnly.substring(0, 2), 10);
    m = parseInt(numbersOnly.substring(2, 4), 10);
  }
  
  if (isNaN(h)) h = 0;
  if (isNaN(m)) m = 0;
  
  if (h === 12 && !isPM) h = 0;
  if (h < 12 && isPM) h += 12;
  
  if (h > 23) h = 23;
  if (m > 59) m = 59;
  
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

export const SmartTimeInput = ({ value, onChange, disabled, className }) => {
  const [displayValue, setDisplayValue] = useState(formatTimeForDisplay(value));

  useEffect(() => {
    setDisplayValue(formatTimeForDisplay(value));
  }, [value]);

  const handleBlur = () => {
    if (!displayValue.trim()) {
      onChange('');
      return;
    }
    const parsed = parseTimeTo24(displayValue);
    onChange(parsed);
    setDisplayValue(formatTimeForDisplay(parsed));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  };

  return (
    <input
      type="text"
      disabled={disabled}
      className={className}
      value={displayValue}
      onChange={(e) => setDisplayValue(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      placeholder="e.g. 6"
    />
  );
};
